import Vue from 'vue'
import Vuex from 'vuex'
import TicketCenter from '@/pages/Ticket/Center/models/index.js'
import ReimModels from '@/pages/Reimbursement/models/index.js'
import ApplyInfo from '@/pages/Customer/ApplyInfo/models/index.js'
import AuditInvoicing from '@/pages/Invoice/AuditInvoicing/models/index.js'
import FaceRecognitionModel from '@/pages/FaceRecognition/models/index.js'
import ETaxLogin from '@/pages/ETaxLogin/models/index.js'
import InvoiceOpeningModel from '@/pages/Invoice/InvoiceOpening/models/index.js'
import MessageModel from '@/pluspages/Message/models/index.js'
import InvoiceRedModel from '@/pages/Invoice/InvoiceRed/models/index.js'
import DoneInvoiceListModel from '@/pages/Invoice/DoneInvoiceList/models/index.js'
import MyExamineModel from '@/pages/MyExamine/models/index.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    faceRecognitionModel: FaceRecognitionModel,
    eTaxLogin: ETaxLogin,
    auditInvoicing: AuditInvoicing,
    ticketCenter: TicketCenter,
    myExamineModel: MyExamineModel,
    reimModels: ReimModels,
    applyInfo: ApplyInfo,
    messageModel: MessageModel,
    invoiceRedModel: InvoiceRedModel,
    invoiceOpeningModel: InvoiceOpeningModel,
    doneInvoiceListModel: DoneInvoiceListModel
  }
})
